module.exports = __webpack_public_path__ + "images/icons/flags/BE-cfe355da.svg";